<div class="mfa-confirm">
    <h2 class="mfa-confirm__title">
        {{ "Enable Two-Factor Authentication?" | translate }}
    </h2>
    <p class="mfa-confirm__text">
        {{ "All users of this company will be required to authenticate using Microsoft Authenticator on their next login. This cannot be undone without manually disabling MFA again"| translate }}
    </p>
    <div class="mfa-confirm__actions">
        <button type="button" class="bx-btn bx-btn-primary d-inline-flex align-items-center mr-20" (click)="close(true)">
            {{ "Yes, Enable MFA" | translate }}
        </button>
        <button type="button" class="bx-btn bx-btn-danger" (click)="close(false)">
            {{ "Cancel" | translate }}
        </button>
    </div>
</div>